import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import routerConfig from './router';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import store from './model/index';
import userStorage from './utils/storage';
import App from './App';

ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
      <Switch>
        {routerConfig.map(
          ({ component: Component, path, redirect, auth, exact }, key) => {
            return (
              <Route
                path={path}
                exact={exact}
                key={key}
                render={props => {
                  if (redirect) {
                    return <Redirect to={redirect} />;
                  }
                  if (auth) {
                    if (userStorage.token) {
                      return (
                        <App {...props}>
                          <Component {...props} />
                        </App>
                      );
                    } else {
                      return <Redirect to="/login" />;
                    }
                  } else {
                    return <Component {...props} />;
                  }
                }}
              />
            );
          }
        )}
        <Redirect to="/404" />
      </Switch>
    </HashRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
